<template>
  <main>
    <div class="page-content">
   <div class="container-fluid">
      <!-- start page title -->
      <div class="row">
         <div class="col-12">
            <div class="page-title-box d-flex align-items-center justify-content-between">
               <h4 class="mb-0 font-size-18">Console</h4>
               <div class="page-title-right">
                  <ol class="breadcrumb m-0">
                     <li class="breadcrumb-item"><a href="javascript: void(0);">Your Servers</a></li>
                     <li class="breadcrumb-item active">Console</li>
                  </ol>
               </div>
            </div>
         </div>
      </div>

      <div class="row">
         <div class="col-xl-4">
            <div class="card">
               <div class="card-body border-bottom" style="padding-top:8%">
                  <center>
                     <h3 class="">Server Status: <span :class="statusClass(status)">{{ status | caps }}</span></h3>
                  </center>
               </div>
               <div class="card-body border-bottom">
                  <div>
                     <div class="row">
                        <div class="col-sm-6">
                           <div>
                              <p class="text-muted mb-2">Server Actions</p>
                              <div class="col-md-6">
                                 <div class="btn-group" role="group" aria-label="Basic example">
                                    <button type="button" class="btn btn-light" v-on:click="sendStatusAction('start')" :disabled="status == 'online'">Start</button>
                                    <button type="button" class="btn btn-light" v-on:click="sendStatusAction('stop')" :disabled="status == 'offline'">Stop</button>
                                    <button type="button" class="btn btn-light" v-on:click="sendStatusAction('restart')">Restart</button>
                                 </div>
                              </div>
                           </div>
                        </div>
                        <div class="col-sm-6">
                           <div class="text-sm-right mt-4 mt-sm-0">
                              <p class="text-muted mb-2">Server Not Responding?</p>
                              <button type="button" class="btn btn-danger waves-effect btn-label waves-light" data-toggle="modal" data-target="#myModal"><i class="bx bx-error label-icon "></i> Kill Server</button>
                           </div>
                           <div id="myModal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
                              <div class="modal-dialog">
                                 <div class="modal-content">
                                    <div class="modal-header">
                                       <h5 class="modal-title mt-0" id="myModalLabel">WARNING!</h5>
                                       <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                       <span aria-hidden="true">&times;</span>
                                       </button>
                                    </div>
                                    <div class="modal-body">
                                       <h5>Kill Server</h5>
                                       <p>Doing this may cause irreversible corruption to your server files. Do not use this function unless your server is not responding.</p>
                                    </div>
                                    <div class="modal-footer">
                                       <button type="button" class="btn btn-secondary waves-effect" data-dismiss="modal">Cancel</button>
                                       <button type="button" class="btn btn-danger waves-effect waves-light" v-on:click="sendStatusAction('kill')" data-dismiss="modal">Kill Server</button>
                                    </div>
                                 </div>
                                 <!-- /.modal-content -->
                              </div>
                              <!-- /.modal-dialog -->
                           </div>
                           <!-- /.modal -->
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
         <div class="col-xl-8">
            <!-- end row -->
            <div class="card">
               <div class="card-body">

                  <h4 class="card-title mb-3">Console</h4>
                  <div id="console" class="console">
                    <div class="log" v-for="line in lines" v-html="colourise(line)"> </div>
                  </div>
                  <div class="input-group">
                    <input class="form-control" type="text" placeholder="Send a command..." v-model="command" v-on:keyup.enter="sendCommand">
                    <div class="input-group-append" id="button-addon4">
                      <button type="button" class="btn btn-light waves-effect" v-on:click="sendCommand">Send</button>
                    </div>
                  </div>
               </div>
            </div>
         </div>
         <!-- end row -->
         <!-- end row -->
      </div>
      <!-- end page title -->
      <!-- end row -->
      <!-- end row -->
   </div>
   <!-- container-fluid -->
</div>
  </main>
</template>

<script>
import { default as AnsiUp } from 'ansi_up'

export default {
  name: 'Console',
  data () {
    return {
      command: '',
      lines: [''],
      status: 'loading',
      task: null
    }
  },
  filters: {
    caps: function (data) {
      return data.charAt(0).toUpperCase() + data.slice(1)
    }
  },
  mounted () {
    this.$socket.emit('server:console')
    this.$socket.emit('server:status')
    if (this.task == null) {
      this.task = setInterval(() => {
        document.querySelector('#console').scrollTop = document.querySelector('#console').scrollHeight
      }, 1000)
    }
  },
  destroyed () {
    if (this.task != null) {
      clearInterval(this.task)
    }
  },
  sockets: {
    'server:console': function (data) {
      console.log('logs')
      data = typeof (data) === 'string' ? data.split('\r\n').filter(Boolean) : data
      this.lines = this.lines.concat(data)
    },
    'server:status': function (data) {
      console.log(status)
      this.status = data
    }
  },
  methods: {
    colourise: function (text) {
      const ansiUp = new AnsiUp()
      let html = ansiUp.ansi_to_html(text)
      return html
    },
    sendCommand: function () {
      // this.$socket.emit('server:command', {command: this.command})
      this.$socket.emit('server:command', this.command)
      this.command = ''
    },
    sendStatusAction: function (action) {
      if (!['start', 'stop', 'restart', 'kill'].includes(action)) return
      this.$socket.emit('status:action', action)
    },
    statusClass: function () {
      var baseClass = 'badge '
      switch (this.status) {
        case 'online':
          baseClass += 'badge-success'
          break
        case 'offline':
          baseClass += 'badge-danger'
          break
        default:
          baseClass += 'badge-primary'
      }
      return baseClass
    }
  },
  callback: function () {
    console.log('CALLBACK')
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.console
{
  width: 100%;
  background-color: black;
  height: 350px;
  max-height: 350px;
  overflow: scroll;
  border-radius: 5px;
  font-family: monospace;
  color: white;
  padding: 25px;
  box-sizing: border-box;
  margin-bottom: 15px;
}

/*.input-group-text
{
  background: black;
  border: none;
  border-radius: 0px 0px 0px 5px;
  color: white;
  font-family: monospace;
}
input[type="text"],input[type="text"]:focus
{
  outline: none !important;
  outline-color: transparent !important;
  outline-style: none !important;
  background: black;
  border: none !important;
  color: white;
  font-family: monospace;
  border-radius: 0px 0px 5px 0px;
  box-shadow: none;
}*/
.console p
{
  margin-bottom: 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/panel/Console.vue